import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";

import PrepareDataTable from "./PrepareDataTable";
import { AnalyticalNotesListContainer } from "./AnalyticalNotesList.styled";

import "./AnalyticalNotesList.scss";
import AddEditAnalyticalNote from "../AddEditAnalyticalNote/AddEditAnalyticalNote";

/**
 * AnalyticalNotesList List,
 * Path - /analyticalNotes
 * @see See [AnalyticalNotes Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2881060894/Analytical+notes+form)
 * @component
 */
const AnalyticalNotesList = (props) => {
  const { t, columnList, siteId } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);

  const [isAddAnalyticalNotePopupVisible, setAddAnalyticalNotePopupVisible] =
    useState(false);

  const createSolution = () => {
    setAddAnalyticalNotePopupVisible(true);
  };

  const closeSolutionCreationPopup = () => {
    setAddAnalyticalNotePopupVisible(false);
  };

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <AnalyticalNotesListContainer className="analytical-notes-list">
      <PrepareDataTable
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        columnList={columnList}
        createNewAction={createSolution}
        siteId={siteId}
      />
      {isAddAnalyticalNotePopupVisible && (
        <AddEditAnalyticalNote
          title={t("ANALYTICAL_NOTE")}
          onClose={closeSolutionCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          siteId={siteId}
        />
      )}
    </AnalyticalNotesListContainer>
  );
};

AnalyticalNotesList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AnalyticalNotesList);
